export const OrderDrawerSection = Object.freeze({
  order: 'order',
  'fulfillment-plans': 'fulfillment-plans',
  'ordered-items': 'ordered-items',
  customer: 'customer',
  customs: 'customs',
  notes: 'notes',
  tags: 'tags',
  summary: 'summary',
  pickupInformation: 'pickupInformation',
});
